import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Auth from '../../../../Auth';
import setLoginModalState from 'Actions/setLoginModalState';
import withConfig from 'HOCs/withConfig/withConfig';
import withTrack from 'HOCs/withTrack/withTrack';
import withRouter from 'HOCs/withRouter';
import { shouldShowTips } from 'Helpers/safetyTips';
import { saveReplyRestrictionMetaData } from 'Actions/chatManager';
import { readReplyRestrictionData } from 'Helpers/replyRestriction';
import { injectIntl } from 'react-intl';
import withReplyRestriction from 'HOCs/withReplyRestriction/withReplyRestriction';
import { MEETING_EVENTS } from 'Constants/tracking';
import { AI_VIDEO_ADS_CAMPAIGN_ID } from 'Constants/constants';
import { isMobile } from 'Helpers/devices';

export class ChatContainer extends React.Component {
    static propTypes = {
        onTrack: PropTypes.func,
        item: PropTypes.object,
        trackFilters: PropTypes.object,
        trackFiltersMetadata: PropTypes.object,
        trackOrigin: PropTypes.string,
        setLoginModalState: PropTypes.func,
        router: PropTypes.object,
        toggleFirstTimeUserTips: PropTypes.func,
        onMessageSend: PropTypes.func,
        config: PropTypes.object,
        trackerOrigins: PropTypes.object,
        tipsInitiationPoint: PropTypes.string,
        user: PropTypes.object,
        children: PropTypes.func,
        selectFrom: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
        leadFormName: PropTypes.string,
        leadFormFlow: PropTypes.func,
        saveReplyRestrictionMetaData: PropTypes.func,
        isReplyRestricted: PropTypes.func,
        location: PropTypes.object,
        isMyZone: PropTypes.bool,
        vwoClientInstance: PropTypes.shape({
            activate: PropTypes.func.isRequired,
            track: PropTypes.func.isRequired
        })
    };

    static defaultProps = {
        onTrack: () => { },
        user: {},
        item: {},
        trackFilters: {},
        setLoginModalState: () => {},
        trackFiltersMetadata: {},
        trackOrigin: '',
        onMessageSend: () => {},
        tipsInitiationPoint: '',
        leadFormName: '',
        leadFormFlow: () => {},
        saveReplyRestrictionMetaData: {},
        setToastMessageState: {},
        isReplyRestricted: () => {},
        showChat: true,
        vwoClientInstance: {
            activate: () => {},
            track: () => {}
        }
    };

    componentDidMount() {
        const replyRestrictionData = readReplyRestrictionData();

        if (replyRestrictionData) {
            this.props.saveReplyRestrictionMetaData(replyRestrictionData);
        }

        this.checkIfKYCRestrictionRoute(); // If #kyc route appears in the URL then replace it
    }

    componentDidUpdate(prevProps) {
        if (this.props.tipsInitiationPoint !== prevProps.tipsInitiationPoint
            && this.props.tipsInitiationPoint === 'chat') {
            if (this.setCurrentClicked) {
                this.chatFlow()(false, prevProps.selectFrom, false);
            }
        }
    }

    checkIfKYCRestrictionRoute = () => {
        if (this.props.location.hash && this.props.location.hash.includes('kyc')) {
            this.props.router.replace(this.props.location.pathname);
        }
    }

    oCategoryBrandTrack = this.props.config.get('chat').newChat && this.props.config.get('chat').newChat.tracking;

    trackChat = (event, select_from = 'item_page', extraTrackAttr = {}) => {
        const trackProps = {
            origin: this.props.trackOrigin,
            filters: this.props.trackFilters,
            select_from,
            ...this.props.trackFiltersMetadata,
            ...extraTrackAttr
        };

        this.props.onTrack(event, trackProps);
    };

    onChatKycCb = (callbacked, select_from = 'item_page', shouldTrack = true) => {
        return () => {
            if (this.props.leadFormName) {
                this.props.leadFormFlow(this.chatFlow(callbacked, select_from, shouldTrack), 'onTapChat');
            }
            else {
                this.chatFlow(callbacked, select_from, shouldTrack)();
            }
        };
    }

    onClickChat = callbacked => (select_from = 'item_page', shouldTrack = true) => {
        select_from = this.props.trackOrigin;
        const cb = this.onChatKycCb(callbacked, select_from, shouldTrack);
        const isReplyRestricted = this.props.isReplyRestricted(this.props.item.id, this.props.item.user_id, cb, true);
        const user = Auth?.getUser();
        const { item } = this.props;

        const options = {
            eventProperties: {
                user_id: user ? user.id : 'na',
                this_ad_title: item.title ? item.title : 'na',
                this_ad_id: item.id ? item.id : 'na',
                ad_owner_user_id: item.user_id ? item.user_id : 'na',
                is_this_ad_with_video: item.is_video_generated ? item.is_video_generated : false
            }
        };

        const campaign = isMobile ? AI_VIDEO_ADS_CAMPAIGN_ID.MOBILE : AI_VIDEO_ADS_CAMPAIGN_ID.DESKTOP;

        this.props.vwoClientInstance.track(campaign, 'adpv_chat_click', options);

        if (!isReplyRestricted) {
            cb();
            return;
        }
    };

    chatFlow = (callbacked, select_from = 'item_page', shouldTrack = true) => () => {
        const isMxCl = this.props.config.get('adpvAuto', 'showMXDesign');

        if (!callbacked && shouldTrack) {
            const { location, item } = this.props;
            const { myZoneFilter } = this.props.trackFilters;
            const extraTrackAttr = {
                chosen_option: myZoneFilter || ' ',
                flow_type: this.props.trackOrigin,
                seller_id: item.user_id,
                origin: 'view_item'
            };

            if (location && location.state && location.state.feed_version) {
                extraTrackAttr.feed_version = location.state.feed_version;
            }

            this.trackChat(MEETING_EVENTS.ITEM_TAP_CHAT, select_from, extraTrackAttr);
        }
        const chatRedirect = isMxCl ? `/olxmobbi/nf/chat/new/${this.props.item.id}/${this.props.item.user_id}` : `/nf/chat/new/${this.props.item.id}/${this.props.item.user_id}`;
        const enableLoginAfterMessage = this.props.config.get('login').enableLoginAfterMessage;

        if (Auth.isLoggedIn()) {
            if (!this.props.toggleFirstTimeUserTips || !this.props.config.get('firstTimeSafetyTip') || !shouldShowTips() || this.props.isMyZone) {
                this.props.router.push(chatRedirect);
            }
            else {
                this.props.toggleFirstTimeUserTips('chat');
                this.setCurrentClicked = 'phone_number_control';
            }
        }
        else {
            this.trackChat('item_intent_chat', select_from);

            const loginModalProps = {
                state: true,
                trackProps: { origin: this.props.trackerOrigins.CHAT },
                entryPoint: 1
            };

            if (shouldShowTips()) {
                loginModalProps.redirectTo = chatRedirect;
            }
            else {
                loginModalProps.redirectTo = '';
                loginModalProps.callback = this.onClickChat(true);
            }

            if (enableLoginAfterMessage) {
                loginModalProps.user = this.props.user;
                loginModalProps.itemId = this.props.item.id;
                loginModalProps.callback = this.props.onMessageSend;
                if (this.props.item.id && this.props.item.category_id && this.oCategoryBrandTrack
                    && this.oCategoryBrandTrack[this.props.item.category_id]) {
                    loginModalProps.event = ['item_chat_tap_send_1st_reply', this.oCategoryBrandTrack[this.props.item.category_id]];
                }
                else {
                    loginModalProps.event = 'item_chat_tap_send_1st_reply';
                }

                delete loginModalProps.redirectTo;
            }

            this.props.setLoginModalState(loginModalProps);
        }
    }

    render() {
        return this.props.children({
            clickHandler: this.onClickChat
        });
    }
}

const mapStateToProps = (state, props) => {
    const item = props.isMyZone
        ? state.myZone.adsData[props.itemId]
        : state.items.elements[props.params.id];
    const user = (item && state.users.elements[item.user_id]);

    return {
        trackFilters: state.track.filters,
        trackFiltersMetadata: state.track.filtersMetadata,
        trackOrigin: state.track.origin,
        item,
        user
    };
};

const mapDispatchToProps = dispatch => ({
    setLoginModalState: state => dispatch(setLoginModalState(state)),
    saveReplyRestrictionMetaData: state => dispatch(saveReplyRestrictionMetaData(state))
});

export default compose(
    withRouter,
    withTrack,
    withConfig,
    injectIntl,
    withReplyRestriction,
    connect(mapStateToProps, mapDispatchToProps)
)(ChatContainer);
